<template>
  <div>
    <player ref="video" :videoLink="homeData.banner.videoLink"></player>

    <!-- banner -->
    <banner @play="playVideo" :year="conKeyInfo.year" :data="homeData.banner"></banner>

    <!-- 往届推荐 -->
    <hot v-if="$store.state.isPastHot"></hot>

    <!-- 联系主席 -->
    <chairmans v-if="charimans.length" :speakers="charimans" class="charimans box display-mobile"></chairmans>

    <!-- 演讲专题 -->
    <track-m :tracks="topics" v-if="topics.length"></track-m>
    <track-pc :topics="topics" v-if="topics.length"></track-pc>

    <!-- 热门推荐 Tag -->
    <tags :tags="tags" v-if="this.tags.length"></tags>

    <!-- 一线技术专家 -->
    <speakers :speakers="speakers" v-if="speakers.length"></speakers>

    <!-- 培训板块 -->
    <training :trainings="trainings" v-if="$store.state.training.lectureIds.length"></training>

    <!-- 往届回顾 -->
    <review></review>

    <!-- 为什么来 AS -->
    <comment @play="playVideo"></comment>

    <!-- 参会者分析 -->
    <analytics></analytics>

    <!-- 移动端地图 -->
    <c-map></c-map>

    <!-- 合作伙伴 -->
    <div id="partner">
      <partners :partners="$store.state.partners"></partners>
    </div>

    <!-- Geekbang 全年技术会议推荐 -->
    <timeline v-if="true"></timeline>
  </div>
</template>

<script>
import TrackPc from './track'
import TrackM from './track-m'
import Speakers from './speakers'
import Partners from './partners'
import Timeline from 'gkConUI/com-timeline'
import Banner from './banner'
import Review from './review'
import Comment from './comment'
import tags from './hot-recommend'
// import Analytics from './analytics'
import Analytics from './analytics2'
import Player from './video'
import CMap from '@/components/con-address'
import Chairmans from './chairmans'
import Training from './training'
// import weixinshare from '../../util/weixinshare'
import hot from 'gkConUI/con-hot'

import util from '@/utils'

import { mapState } from 'vuex'
export default {
  components: {
    Banner,
    TrackPc,
    TrackM,
    Speakers,
    Training,
    Timeline,
    Partners,
    Review,
    Comment,
    tags,
    Analytics,
    Player,
    CMap,
    Chairmans,
    hot
  },
  data () {
    return {
      showVideo: false
    }
  },
  provide () {
    return {
      conKeyInfo: this.conKeyInfo
    }
  },
  computed: {
    ...mapState(['info']),
    homeData () {
      return this.$store.state.comConfig['home']
    },
    conKeyInfo () {
      return this.$store.state.conKeyInfo
    },
    speakers () {
      return this.$store.state.speakersArr.filter(s => !s.is_previous).slice(0, 10)
    },
    tags () {
      return this.$store.state.tagsArr.filter(t => Number(t.is_homepage_featured) === 1)
    },
    charimans () {
      return this.$store.state.speakersArr.filter(s => s.typeId === 1 && s.is_previous !== true)
    },
    topics () {
      return this.$store.state.topicsArr.filter(t => Number(t.typeid) !== 1 && t.is_previous !== true)
    },
    trainings () {
      return this.$store.state.training.lectureIds.map(id => this.$store.state.lectures[id])
    }
  },
  updated () {
    util.weixinshare()
  },
  mounted () {
    util.weixinshare()
  },
  beforeDestroy () {
  },
  methods: {
    playVideo (play = true) {
      this.$refs['video'].playVideo(play)
    }
  }
}
</script>

<style lang="sass" scoped>
.box
  padding: 38px 0
.box.charimans
  background-color: #f8f8f8
</style>
